import React from 'react';
import JsonView from '@uiw/react-json-view';
import { nordTheme } from '@uiw/react-json-view/nord';
import { AppShell } from '../app-shell';
import LoadingIndicator from '../../components/loading-indicator/loading-indicator';
import classnames from 'classnames';
import { ProcessTimeline } from '@codametrix/shared-views';
import { ProcessSelection } from '@codametrix/shared-views';
import { sortCaseRuns } from '../../reducers/cases.reducer';
import { FlexCard } from '@codametrix/ui-components';

export class BPMStepsApp extends React.Component<
  AppProps.BPMStepsAppProps,
  {}
> {
  static defaultProps = {
    loading: true
  };

  constructor(props: AppProps.BPMStepsAppProps) {
    super(props);

    this._handleProcessIdChange = this._handleProcessIdChange.bind(this);
  }

  componentDidMount() {
    const url = new URL(window.location.toString());
    const arg = {
      caseId: url.searchParams.get('caseId'),
      processInstanceId: url.searchParams.get('processInstanceId')
    };
    this.props.getBPMDetails(arg);
  }

  _handleProcessIdChange(event: React.MouseEvent) {
    event.preventDefault();
    const target =
      (event.target as HTMLDivElement) || document.createElement('div');
    const linkable = target?.closest('a');
    if (!linkable) return;

    const item = linkable.attributes.getNamedItem('data-process-id');
    if (!item) return;

    const processId = parseInt(item.value);
    if (!processId) return;

    if (processId !== this.props.activeCaseRun.process_instance_id) {
      this.props.setActiveProcessId(processId);
    }
  }

  render() {
    const { props } = this;
    const {
      loading,
      locked,
      stages,
      activeCase,
      activeCaseRun,
      showRawJSON
    } = props;
    const caseRuns = activeCase.caseRuns ? sortCaseRuns(activeCase, {}) : {};
    const styleClasses = ['centered-application', `bpm-steps-app`];
    let inner;
    if (locked) {
      styleClasses.push(`cmx-application-locked`);
    }

    const jsonDisplay = {
      ruleResults: activeCaseRun.ruleResults,
      history: activeCaseRun.history
    };

    if (loading) {
      styleClasses.push(
        `cmx-application-masked`,
        `cmx-application-loading`,
        'loading-view'
      );
      inner = <LoadingIndicator text={`Loading JSON...`} />;
    } else if (stages !== undefined) {
      styleClasses.push(`cmx-application-loaded`);
      inner = (
        <FlexCard
          header={
            <div key="selction">
              <div>
                <h5>Processing Steps</h5>
              </div>
              <ProcessSelection
                caseRuns={caseRuns}
                activeId={activeCaseRun.process_instance_id}
                onClick={this._handleProcessIdChange}
              />
            </div>
          }>
          {!showRawJSON && <ProcessTimeline stages={stages} />}

          {/* If Radv2, show basic JSON */}
          {showRawJSON && (
            <JsonView
              value={jsonDisplay}
              displayObjectSize={false}
              collapsed={false}
              displayDataTypes={false}
              style={nordTheme}
            />
          )}
        </FlexCard>
      );
    }

    return (
      <AppShell registerActivity={props.registerActivity}>
        <div className={classnames(styleClasses)}>
          {locked && (
            <div className="locked-message">
              The case details you were viewing are no longer active.
            </div>
          )}
          <div className="centered-application-wrapper">{inner}</div>
        </div>
      </AppShell>
    );
  }
}
